import {
  containerFluid,
  defaultFont,
  primaryColor,
  defaultBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  grayColor
} from "assets/jss/material-dashboard-pro-react.js";

const headerStyle = () => ({
  appBar: {
    backgroundColor: "#fff",
    boxShadow: "none",
    borderBottom: "0",
    marginBottom: "0",
    position: "relative",
    width: "100%",
    paddingTop: "10px",
    zIndex: "1029",
    color: grayColor[6],
    border: "0",
    borderRadius: "3px",
    padding: "10px 0",
    transition: "all 150ms ease 0s",
    minHeight: "50px",
    display: "block",
    "@media (max-width: 768px)": {
      backgroundColor: "#2A4266"
    }
  },
  flexHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& a img": {
      height: "21px"
    },
    width: "100%",
    "& button, & a": {
      color: "#fff"
    }
  },
  appResponsive: {
    color: "#fff",
    "&:focus": {
      color: "#fff",
    },
    "& svg": {
      width: "24px",
      height: "24px"
    },
  },
  container: {
    ...containerFluid,
    minHeight: "50px",
    "@media (max-width: 480px)": {
      display: "block"
    }
  },
  flex: {
    flex: 1
  },
  title: {
    ...defaultFont,
    fontFamily: "Fira Sans",
    lineHeight: "29px",
    fontSize: "24px",
    fontWeight: 300,
    borderRadius: "3px",
    textTransform: "none",
    color: "#2A4266",
    paddingTop: "0.625rem",
    paddingBottom: "0.625rem",
    margin: "0 !important",
    letterSpacing: "unset",
    paddingRight: "0",
    paddingLeft: "15px",
    "&:hover,&:focus": {
      background: "transparent"
    },
    "@media (max-width: 480px)": {
      paddingLeft: "10px"
    },
    "& span": {
      fontWeight: 300
    }
  },
  primary: {
    backgroundColor: primaryColor[0],
    color: whiteColor,
    ...defaultBoxShadow
  },
  info: {
    backgroundColor: infoColor[0],
    color: whiteColor,
    ...defaultBoxShadow
  },
  success: {
    backgroundColor: successColor[0],
    color: whiteColor,
    ...defaultBoxShadow
  },
  warning: {
    backgroundColor: warningColor[0],
    color: whiteColor,
    ...defaultBoxShadow
  },
  danger: {
    backgroundColor: dangerColor[0],
    color: whiteColor,
    ...defaultBoxShadow
  },
  sidebarMinimize: {
    float: "left",
    padding: "0 0 0 15px",
    display: "block",
    color: grayColor[6]
  },
  sidebarMinimizeRTL: {
    padding: "0 15px 0 0 !important"
  },
  sidebarMiniIcon: {
    width: "20px",
    height: "17px"
  }
});

export default headerStyle;
